/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

var DateTimePickerProps = {
  cancelBtn: {
    type: String,
    default: "\u53D6\u6D88"
  },
  confirmBtn: {
    type: String,
    default: ""
  },
  end: {
    type: [String, Number]
  },
  format: {
    type: String,
    default: "YYYY-MM-DD HH:mm:ss"
  },
  mode: {
    type: [String, Array],
    default: "date"
  },
  renderLabel: {
    type: Function
  },
  showWeek: Boolean,
  start: {
    type: [String, Number]
  },
  title: {
    type: String,
    default: "\u9009\u62E9\u65F6\u95F4"
  },
  value: {
    type: [String, Number]
  },
  modelValue: {
    type: [String, Number]
  },
  defaultValue: {
    type: [String, Number]
  },
  onCancel: Function,
  onChange: Function,
  onConfirm: Function,
  onPick: Function
};

export { DateTimePickerProps as default };
//# sourceMappingURL=props.js.map
